import { animated, config, useSpring } from '@react-spring/web';
import { memo } from 'react';

import { Check } from '@air/next-icons';

export const FileStatusIconCompleted = memo(() => {
  const [props] = useSpring(
    () => ({
      config: config.wobbly,
      from: { scale: 0 },
      to: { scale: 1 },
    }),
    [],
  );

  return (
    <div aria-hidden className="mr-3 flex size-10 items-center justify-center rounded-full bg-grass-4">
      <animated.div className="flex items-center justify-center" style={props}>
        <Check className="size-6 fill-grass-11" />
      </animated.div>
    </div>
  );
});

FileStatusIconCompleted.displayName = 'FileStatusIconCompleted';
